import type { Config } from 'driver.js';

export const sharedDriverConfig: Partial<Config> = {
  animate: true,
  smoothScroll: true,
  stagePadding: 8,
  stageRadius: 8,
  allowClose: true,
  overlayOpacity: 0.5,
  // Prevent interaction with highlighted elements during the tour overlay.
  // Without this, users could click through the overlay on the active element
  // (clickjacking), triggering unintended actions mid-tour.
  disableActiveInteraction: true,
  // popoverClass adds an *additional* class — driver.js already applies
  // 'driver-popover' by default, so no extra class is needed here.
  showProgress: true,
  progressText: '{{current}} of {{total}}',
  nextBtnText: 'Next',
  prevBtnText: 'Back',
  doneBtnText: 'Done',
};
